import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MentionActionWrapper from 'owa-service/lib/contract/MentionActionWrapper';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';

const MAX_DATABASE_ENTRIES = 23;

export default function loadAtMentionsData(
    viewState: AtMentionsViewState,
    isSend: boolean,
    message: Message
) {
    // Stamp mentions related properties here, as they differ for send vs save.
    if (isSend) {
        const userSession = getUserConfiguration().SessionSettings;
        const mentionWrappers = getMentionsWrappersForSend(viewState, {
            MailboxType: 'Mailbox',
            RoutingType: 'SMTP',
            EmailAddress: userSession.UserEmailAddress,
            Name: userSession.UserDisplayName,
        });
        if (mentionWrappers && mentionWrappers.length > 0) {
            message.MentionsEx = mentionWrappers;
        }
    } else {
        const pendingTags = getPendingTagsForSave(viewState);
        if (pendingTags.length > 0) {
            message.PendingSocialActivityTagIds = pendingTags;
        }
    }
}

function getMentionsWrappersForSend(
    viewState: AtMentionsViewState,
    fromWrapper: EmailAddressWrapper
): MentionActionWrapper[] {
    const { atMentionTuples } = viewState;
    const mentionsWrappers: MentionActionWrapper[] = [];

    Object.keys(atMentionTuples).forEach(key => {
        const persona = atMentionTuples[key];
        mentionsWrappers.push({
            Mentioned: persona.EmailAddress,
            CreatedBy: fromWrapper,
        });
    });
    if (mentionsWrappers.length > 0) {
        const totalMentions = mentionsWrappers.length;
        logUsage('MentionsTotalSend', {
            totalMentions: (totalMentions >= MAX_DATABASE_ENTRIES
                ? MAX_DATABASE_ENTRIES
                : totalMentions
            ).toString(),
        });
    }

    return mentionsWrappers;
}

function getPendingTagsForSave(viewState: AtMentionsViewState): string[] {
    const pendingTags: string[] = [];
    const { atMentionTuples, mentionsAddedRecipients } = viewState;

    Object.keys(atMentionTuples).forEach(key => {
        const persona = atMentionTuples[key];
        pendingTags.push(
            JSON.stringify({
                b: key,
                a: JSON.stringify({
                    _type: 'MentionActionWrapper:#Exchange',
                    Mentioned: persona.EmailAddress,
                }),
            })
        );
    });
    if (mentionsAddedRecipients.length > 0) {
        pendingTags.push(
            JSON.stringify({
                b: 'MentionAddedRecipients',
                a: JSON.stringify(mentionsAddedRecipients),
            })
        );
    }
    if (pendingTags.length > 0) {
        const totalMentions = Object.keys(atMentionTuples).length;
        const numberAddedViaMentions = mentionsAddedRecipients.length;
        logUsage('MentionsTotalSave', {
            totalMentions: (totalMentions >= MAX_DATABASE_ENTRIES
                ? MAX_DATABASE_ENTRIES
                : totalMentions
            ).toString(),
            numberAddedViaMentions: (numberAddedViaMentions >= MAX_DATABASE_ENTRIES
                ? MAX_DATABASE_ENTRIES
                : numberAddedViaMentions
            ).toString(),
        });
    }

    return pendingTags;
}
